import { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: 'cash-flow',
    component: () => import('@/app/cash-flow/layouts/index.vue'),
    name: 'app.cash_flow',
    children: [
      {
        path: 'projects-billed',
        component: () => import('@/app/cash-flow/pages/projects-billed.vue'),
        name: 'app.cash_flow.projects_billed',
      },
      {
        path: 'projects-expected',
        component: () => import('@/app/cash-flow/pages/projects-expected.vue'),
        name: 'app.cash_flow.projects_expected',
      },
      {
        path: 'general-expenses',
        component: () => import('@/app/cash-flow/pages/general-expenses.vue'),
        name: 'app.cash_flow.general_expenses',
      },
      {
        path: 'salary-contribution-else',
        component: () =>
          import('@/app/cash-flow/pages/salary-contribution-else.vue'),
        name: 'app.cash_flow.salary_contribution_else',
      },
      {
        path: 'vat',
        component: () => import('@/app/cash-flow/pages/vat.vue'),
        name: 'app.cash_flow.vat',
      },
      {
        path: 'detailed',
        component: () => import('@/app/cash-flow/pages/detailed.vue'),
        name: 'app.cash_flow.detailed',
      },
      {
        path: 'monthly-summary',
        component: () => import('@/app/cash-flow/pages/monthly-summary.vue'),
        name: 'app.cash_flow.monthly_summary',
      },
    ],
  },
];

export default routes;
